import React, { Component } from 'react';

//import {Form, Field, TreeSelect, TFAVerification, ResetPassword, Checklist} from './Form/Form.js';
import {Form, Field, TreeSelect, Checklist, ToggleSwitch} from '../Form/Form.js';
import { Formik } from 'formik';
import DeleteButton from './../common/DeleteButton';
import * as Yup from 'yup';
import * as diff from 'object-diff';

//import Footer from './Footer';

class UserEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      permissions: [],
      roles: [],
      rolesKey: [].toString(),
      loading: true,
      verificationLink: null,
      resetPasswordLink: null,
      verified: props.user.verified,
      initialValues: {
        username: props.user.uid,
        email: props.user.email,
        firstName: props.user.firstName,
        lastName: props.user.lastName,
        permissions: [],
        enabled: props.user.enabled,
        currentPassword: "",
      },
    }
  }

  componentDidMount() {
    Promise.all([this.getAvailableGroups(), this.getRoles()])
      .then((results) => this.setState({loading: false}));
  }

  getRoles = () => {
    return fetch(
      "/api/getRoles",
      {
        method: "POST",
        body: JSON.stringify({username: this.state.initialValues.username}),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        throw(res.statusText);
      } else {
        return res.json();
      }
    })
    .then(data => {
      let initialValues = this.state.initialValues;
      initialValues.roles = data.filter(role => role.checked)
        .map(role => role.name);
      this.setState({initialValues: initialValues, roles: data})
    })
    .catch(error => console.log(error));
  }

  getAvailableGroups = () => {
    return fetch(
      "/api/getAvailableGroups",
      {
        method: "POST",
        body: JSON.stringify({username: this.state.initialValues.username}),
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then(res => {
      if (!res.ok) {
        throw(res.statusText);
      } else {
        return res.json();
      }
    })
    .then(data => {
      let tree = this.buildGroupsTree(data);
      let state = this.buildDropdownStateFromTree(tree);
      this.setState({permissions: state});
    })
    .catch(error => console.log(error));
  }

  buildGroupsTree = (groups) => {
    let tree = {};
    groups.forEach((group) => {
      let curTree = tree;
      let components = group.dn.split(',').reverse();
      components
        .map((component) => component.split('=')[1])
        .forEach((nodeName, i) => {
          if (!curTree[nodeName])
            curTree[nodeName] = {}
          curTree = curTree[nodeName]

          if (i === components.length - 1) {
            curTree.checked = group.checked;
            curTree.value = group.dn; 
          } else {
            if (!curTree.children)
              curTree.children = {};
            curTree = curTree.children;
          }
        })
    })

    return tree;
  }

  buildDropdownStateFromTree = (tree, checked) => {
    let state = [];
    for (let key in tree) {
      let newNode = {};
      newNode.label = key;
      newNode.value = tree[key].value;
      newNode.checked = tree[key].checked || checked;
      newNode.children = this.buildDropdownStateFromTree(tree[key].children, newNode.checked);
      state.push(newNode);

      if (tree[key].checked) {
        let initialValues = this.state.initialValues;
        initialValues.permissions.push(newNode.value)
        this.setState({initialValues: initialValues});
      }
    }
    return state;
  }

  sendVerificationLink = ({values, errors, setFieldValue, setFieldTouched, setFieldError}) => {
    if (!values.currentPassword || values.currentPassword === "") {
      return setFieldTouched("currentPassword", true);
    }

    if (errors.email) {
      return setFieldTouched("email", true);
    }

    let {username, email, currentPassword} = values;
    fetch(
      "/api/sendVerificationLink",
      {
        method: "POST",
        body: JSON.stringify({username, email, currentPassword}),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        if (res.status === 401) {
          alert("Wrong Password");
        } else {
          throw Error(res.statusText);
        }
      } else {
        return res.json();
      }
    })
    .then(data => {
      alert("Verification Link Sent");
      this.setState({verificationLink: data});
      setFieldValue("currentPassword", "");
      setFieldTouched("currentPassword", false);
    })
    .catch(error => console.log(error));
  }

  sendPasswordResetLink = ({values, setFieldTouched, setFieldError, errors, setFieldValue}) => {
    if (!values.currentPassword || values.currentPassword === "") {
      setFieldTouched("currentPassword", true, false);
      setFieldError("currentPassword", "Please enter your current password");
      return;
    }

    if (errors.email) {
      return setFieldTouched("email", true, false);
    }
    
    fetch('/api/sendPasswordResetLink', {
      method: "POST",
      body: JSON.stringify({username: values.username, email: values.email, currentPassword: values.currentPassword}),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    })
    .then(res => {
      if (!res.ok) {
        if (res.status === 401) {
          alert("Wrong Password");
        } else {
          throw Error(res.statusText);
        }
      } else {
        return res.json();
      }
    })
    .then(data => {
      alert("Password reset successful!");
      this.setState({resetPasswordLink: data});
      setFieldValue("currentPassword", "");
      setFieldTouched("currentPassword", false);
    })
    .catch(error => console.log(error));
  }

  submitEditUser = (values, actions) => {
    let { username } = values;
    fetch(
      '/api/editUser',
      {
        method: "POST",
        body: JSON.stringify({username, ...diff(this.state.initialValues, values)}),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        if (res.status === 401) {
          alert("Incorrect Password");
        } else if (res.status === 400) {
          res.json().then(errors => actions.setErrors(errors));
        } else {
          alert("Could Not Edit User");
          throw Error(res.statusText);
        }
      } else {
        alert("Edited Succesfully");
        this.props.cancelEditUser();
      }
    })
    .catch(error => console.log(error))
    .then(() => {
      actions.setFieldValue('currentPassword', '', false);
      actions.setSubmitting(false);
    });
  }

  deleteUser = ({ values, setFieldTouched, setFieldValue }) => {
    if (!values.currentPassword || values.currentPassword === "") {
      return setFieldTouched("currentPassword", true);
    }

    this.setState({ loading: true });
    fetch(
      '/api/deleteUser',
      {
        method: "POST",
        body: JSON.stringify({ username: this.props.user.uid, currentPassword: values.currentPassword }),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then((res) => {
      if (!res.ok) {
        if (res.status === 401) {
          alert("Incorrect Password");
        } else {
          alert("An error occured");
          throw Error(res.statusText);
        }
      } else {
        alert("User deleted!");
        this.props.cancelEditUser();
      }
    })
    .catch(error => console.log(error))
    .then(() => {
      this.setState({ loading: false });
      setFieldValue('currentPassword', '', false);
    });
  }

  validationSchema = () => {
    return Yup.object()
      .shape({
        currentPassword: Yup.string().ensure()
          .required('Required!')
          .max(128, "Too long!"),
        firstName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid first name!"),
        lastName: Yup.string().ensure()
          .required('Required!')
          .min(2, 'Too short!')
          .max(30, 'Too long!')
          .matches(/^[a-zA-Z]+(-[a-zA-Z]+)?$/, "Please enter a valid last name!"),
        email: Yup.string().ensure()
          .required('Required!')
          .email("Please enter a valid email!"),
      })
  }

  render = () => {
    return(
      <Formik initialValues={this.state.initialValues} onSubmit={this.submitEditUser} validationSchema={this.validationSchema()}>
        {
          ({values, touched, errors, dirty, isValid, isSubmitting, handleChange, handleBlur, handleSubmit, handleReset, setFieldValue, setFieldError, setFieldTouched}) => {
            const propsForField = {values, touched, errors, handleChange, handleBlur, setFieldValue, setFieldError, setFieldTouched, dirty};
            return (
              <div className={!values.enabled || !this.state.verified ? "formDisabled" : ""}>
                <Form title={`Edit User`} onSubmit={handleSubmit} isLoading={isSubmitting || this.state.loading}>
                  <Field id="username" fieldName="Username" disabled {...propsForField} />
                  <Field id="firstName" fieldName="First Name" {...propsForField} />
                  <Field id="lastName" fieldName="Last Name" {...propsForField} />
                  <Field id="email" type="email" fieldName="Email" {...propsForField} />

                  <ToggleSwitch id="enabled" fieldName={values.enabled ? "Enabled" : "Disabled"} disabled={!this.state.verified} {...propsForField} />

                  <div className="form-group">
                    <div className="col-md-4"></div>
                    <div className="col-md-8">{this.state.verified ? "" : "NOTE: This account cannot be enabled since it has not been verified yet"}</div>
                  </div>

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <Checklist key={this.state.rolesKey} label="Roles" data={this.state.roles} {...propsForField}/>

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <TreeSelect data={this.state.permissions} {...propsForField} />

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <div className="form-group">
                    <label className="col-md-4 control-label">Two-Factor Authentication</label>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="button" className="btn btn-light" onClick={() => this.sendVerificationLink(propsForField)}>Send Verification Link</button>
                        </div>
                        {
                        this.state.verificationLink &&
                        <div className="col-md-6">
                          <a href={this.state.verificationLink} target="_blank"><button type="button" className="btn btn-primary">Go To Verification Link</button></a>
                        </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="col-md-4 control-label">Reset Password</label>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="button" id="resetPasswordButton" className="btn btn-light" onClick={() => this.sendPasswordResetLink(propsForField)}>
                            Send Reset Password Link
                          </button>
                        </div>
                        {
                          this.state.resetPasswordLink &&
                          <div className="col-md-6">
                            <a href={this.state.resetPasswordLink} target="_blank"><button type="button" className="btn btn-primary">Go To Password Reset Link</button></a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>


                  <DeleteButton onClick={() => this.deleteUser(propsForField)} />

                  <hr style={{margin: "40px 0px", marginLeft: "20px"}} />

                  <Field id="currentPassword" fieldName="Current Password" type="password" {...propsForField} />

                  <div className="form-group">
                    <label className="col-md-4 control-label"></label>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary" disabled={!dirty}>Save Changes</button>
                        </div>
                        <div className="col-md-6">
                          <button type="button" className="btn btn-light" onClick={this.props.cancelEditUser}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging' ? 
                    <pre>
                      {`${JSON.stringify(diff(this.state.initialValues, values), null, 2)}\n\n`}
                      {`${JSON.stringify(values, null, 2)}`}
                      {`\n\nisDirty: ${dirty}`}
                      </pre> : null
                  }
                </Form>
              </div>
            );
          }
        }
      </Formik>
    );
  }
}
export default UserEdit;



// WEBPACK FOOTER //
// ./src/Components/userManagement/UserEdit.js